import React, { Component } from "react";

export class EffectStripped extends Component<any, any> {
    constructor(props) {
        super(props);

        props.onChange && props.onChange(props);
    }

    componentDidMount() {
        const { isValid, validateForm } = this.props;
        if (!isValid) {
            validateForm();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            this.props.errors !== nextProps.errors ||
            this.props.isValid !== nextProps.isValid ||
            this.props.values !== nextProps.values
        ) {
            nextProps.onChange && nextProps.onChange(nextProps);
        }
    }

    render() {
        return null;
    }
}
